import script from "./inputComboBox.vue?vue&type=script&setup=true&lang=ts"
export * from "./inputComboBox.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__